import { ca } from '@cian/analytics';

export const trackCoPromosShow = () => {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'BlackFriday',
    name: 'oldevent',
    label: 'exclusive_promos',
  });
};
